// Cantones del Ecuador: Clasificador Geográfico Estadístico (CGE) 2026 del INEC, hoja CANTONES de
// CODIFICACIÓN_2026.xlsx, dentro de CLASIFICADOR_GEOGRAFICO_2026.zip (archivo fechado el 09/03/2026),
// https://www.ecuadorencifras.gob.ec/documentos/web-inec/Cartografia/Clasificador_Geografico/CLASIFICADOR_GEOGRAFICO_2026.zip
// Descargado el 26/10/2026; SHA-256 del zip 9a2962bcccd88745dba4d61627e27945714049d97571d088e6c6b294be668a2c
// (copia en STORSAFE_PRIVADO\referencias\inec_cge_2026, fuera del repo).
// 222 cantones en 24 provincias (incluye Sevilla Don Bosco, 1413). No se incluyen las 2 "zonas en estudio"
// (código 90: Juval y Sinaí-Cuchaentza) porque no son cantones. Nombres tal como los escribe el INEC.
// Archivo generado; no editar a mano.

export interface CantonInec { codigo: string; canton: string; provincia: string; codigoProvincia: string }

export const FUENTE_CANTONES = 'INEC, Clasificador Geográfico Estadístico 2026 (CODIFICACIÓN_2026.xlsx, 09/03/2026)';

const DATOS: [string, string, string][] = [
  ['0101', 'CUENCA', 'AZUAY'],
  ['0102', 'GIRÓN', 'AZUAY'],
  ['0103', 'GUALACEO', 'AZUAY'],
  ['0104', 'NABÓN', 'AZUAY'],
  ['0105', 'PAUTE', 'AZUAY'],
  ['0106', 'PUCARÁ', 'AZUAY'],
  ['0107', 'SAN FERNANDO', 'AZUAY'],
  ['0108', 'SANTA ISABEL', 'AZUAY'],
  ['0109', 'SÍGSIG', 'AZUAY'],
  ['0110', 'OÑA', 'AZUAY'],
  ['0111', 'CHORDELEG', 'AZUAY'],
  ['0112', 'EL PAN', 'AZUAY'],
  ['0113', 'SEVILLA DE ORO', 'AZUAY'],
  ['0114', 'GUACHAPALA', 'AZUAY'],
  ['0115', 'CAMILO PONCE ENRÍQUEZ', 'AZUAY'],
  ['0201', 'GUARANDA', 'BOLÍVAR'],
  ['0202', 'CHILLANES', 'BOLÍVAR'],
  ['0203', 'CHIMBO', 'BOLÍVAR'],
  ['0204', 'ECHEANDÍA', 'BOLÍVAR'],
  ['0205', 'SAN MIGUEL', 'BOLÍVAR'],
  ['0206', 'CALUMA', 'BOLÍVAR'],
  ['0207', 'LAS NAVES', 'BOLÍVAR'],
  ['0301', 'AZOGUES', 'CAÑAR'],
  ['0302', 'BIBLIÁN', 'CAÑAR'],
  ['0303', 'CAÑAR', 'CAÑAR'],
  ['0304', 'LA TRONCAL', 'CAÑAR'],
  ['0305', 'EL TAMBO', 'CAÑAR'],
  ['0306', 'DÉLEG', 'CAÑAR'],
  ['0307', 'SUSCAL', 'CAÑAR'],
  ['0401', 'TULCÁN', 'CARCHI'],
  ['0402', 'BOLÍVAR', 'CARCHI'],
  ['0403', 'ESPEJO', 'CARCHI'],
  ['0404', 'MIRA', 'CARCHI'],
  ['0405', 'MONTÚFAR', 'CARCHI'],
  ['0406', 'SAN PEDRO DE HUACA', 'CARCHI'],
  ['0501', 'LATACUNGA', 'COTOPAXI'],
  ['0502', 'LA MANÁ', 'COTOPAXI'],
  ['0503', 'PANGUA', 'COTOPAXI'],
  ['0504', 'PUJILÍ', 'COTOPAXI'],
  ['0505', 'SALCEDO', 'COTOPAXI'],
  ['0506', 'SAQUISILÍ', 'COTOPAXI'],
  ['0507', 'SIGCHOS', 'COTOPAXI'],
  ['0601', 'RIOBAMBA', 'CHIMBORAZO'],
  ['0602', 'ALAUSÍ', 'CHIMBORAZO'],
  ['0603', 'COLTA', 'CHIMBORAZO'],
  ['0604', 'CHAMBO', 'CHIMBORAZO'],
  ['0605', 'CHUNCHI', 'CHIMBORAZO'],
  ['0606', 'GUAMOTE', 'CHIMBORAZO'],
  ['0607', 'GUANO', 'CHIMBORAZO'],
  ['0608', 'PALLATANGA', 'CHIMBORAZO'],
  ['0609', 'PENIPE', 'CHIMBORAZO'],
  ['0610', 'CUMANDÁ', 'CHIMBORAZO'],
  ['0701', 'MACHALA', 'EL ORO'],
  ['0702', 'ARENILLAS', 'EL ORO'],
  ['0703', 'ATAHUALPA', 'EL ORO'],
  ['0704', 'BALSAS', 'EL ORO'],
  ['0705', 'CHILLA', 'EL ORO'],
  ['0706', 'EL GUABO', 'EL ORO'],
  ['0707', 'HUAQUILLAS', 'EL ORO'],
  ['0708', 'MARCABELÍ', 'EL ORO'],
  ['0709', 'PASAJE', 'EL ORO'],
  ['0710', 'PIÑAS', 'EL ORO'],
  ['0711', 'PORTOVELO', 'EL ORO'],
  ['0712', 'SANTA ROSA', 'EL ORO'],
  ['0713', 'ZARUMA', 'EL ORO'],
  ['0714', 'LAS LAJAS', 'EL ORO'],
  ['0801', 'ESMERALDAS', 'ESMERALDAS'],
  ['0802', 'ELOY ALFARO', 'ESMERALDAS'],
  ['0803', 'MUISNE', 'ESMERALDAS'],
  ['0804', 'QUININDÉ', 'ESMERALDAS'],
  ['0805', 'SAN LORENZO', 'ESMERALDAS'],
  ['0806', 'ATACAMES', 'ESMERALDAS'],
  ['0807', 'RIOVERDE', 'ESMERALDAS'],
  ['0901', 'GUAYAQUIL', 'GUAYAS'],
  ['0902', 'ALFREDO BAQUERIZO MORENO (JUJÁN)', 'GUAYAS'],
  ['0903', 'BALAO', 'GUAYAS'],
  ['0904', 'BALZAR', 'GUAYAS'],
  ['0905', 'COLIMES', 'GUAYAS'],
  ['0906', 'DAULE', 'GUAYAS'],
  ['0907', 'DURÁN', 'GUAYAS'],
  ['0908', 'EL EMPALME', 'GUAYAS'],
  ['0909', 'EL TRIUNFO', 'GUAYAS'],
  ['0910', 'MILAGRO', 'GUAYAS'],
  ['0911', 'NARANJAL', 'GUAYAS'],
  ['0912', 'NARANJITO', 'GUAYAS'],
  ['0913', 'PALESTINA', 'GUAYAS'],
  ['0914', 'PEDRO CARBO', 'GUAYAS'],
  ['0916', 'SAMBORONDÓN', 'GUAYAS'],
  ['0918', 'SANTA LUCÍA', 'GUAYAS'],
  ['0919', 'SALITRE', 'GUAYAS'],
  ['0920', 'SAN JACINTO DE YAGUACHI', 'GUAYAS'],
  ['0921', 'PLAYAS', 'GUAYAS'],
  ['0922', 'SIMÓN BOLÍVAR', 'GUAYAS'],
  ['0923', 'CORONEL MARCELINO MARIDUEÑA', 'GUAYAS'],
  ['0924', 'LOMAS DE SARGENTILLO', 'GUAYAS'],
  ['0925', 'NOBOL', 'GUAYAS'],
  ['0927', 'GENERAL ANTONIO ELIZALDE', 'GUAYAS'],
  ['0928', 'ISIDRO AYORA', 'GUAYAS'],
  ['1001', 'IBARRA', 'IMBABURA'],
  ['1002', 'ANTONIO ANTE', 'IMBABURA'],
  ['1003', 'COTACACHI', 'IMBABURA'],
  ['1004', 'OTAVALO', 'IMBABURA'],
  ['1005', 'PIMAMPIRO', 'IMBABURA'],
  ['1006', 'SAN MIGUEL DE URCUQUÍ', 'IMBABURA'],
  ['1101', 'LOJA', 'LOJA'],
  ['1102', 'CALVAS', 'LOJA'],
  ['1103', 'CATAMAYO', 'LOJA'],
  ['1104', 'CELICA', 'LOJA'],
  ['1105', 'CHAGUARPAMBA', 'LOJA'],
  ['1106', 'ESPÍNDOLA', 'LOJA'],
  ['1107', 'GONZANAMÁ', 'LOJA'],
  ['1108', 'MACARÁ', 'LOJA'],
  ['1109', 'PALTAS', 'LOJA'],
  ['1110', 'PUYANGO', 'LOJA'],
  ['1111', 'SARAGURO', 'LOJA'],
  ['1112', 'SOZORANGA', 'LOJA'],
  ['1113', 'ZAPOTILLO', 'LOJA'],
  ['1114', 'PINDAL', 'LOJA'],
  ['1115', 'QUILANGA', 'LOJA'],
  ['1116', 'OLMEDO', 'LOJA'],
  ['1201', 'BABAHOYO', 'LOS RÍOS'],
  ['1202', 'BABA', 'LOS RÍOS'],
  ['1203', 'MONTALVO', 'LOS RÍOS'],
  ['1204', 'PUEBLOVIEJO', 'LOS RÍOS'],
  ['1205', 'QUEVEDO', 'LOS RÍOS'],
  ['1206', 'URDANETA', 'LOS RÍOS'],
  ['1207', 'VENTANAS', 'LOS RÍOS'],
  ['1208', 'VINCES', 'LOS RÍOS'],
  ['1209', 'PALENQUE', 'LOS RÍOS'],
  ['1210', 'BUENA FE', 'LOS RÍOS'],
  ['1211', 'VALENCIA', 'LOS RÍOS'],
  ['1212', 'MOCACHE', 'LOS RÍOS'],
  ['1213', 'QUINSALOMA', 'LOS RÍOS'],
  ['1301', 'PORTOVIEJO', 'MANABÍ'],
  ['1302', 'BOLÍVAR', 'MANABÍ'],
  ['1303', 'CHONE', 'MANABÍ'],
  ['1304', 'EL CARMEN', 'MANABÍ'],
  ['1305', 'FLAVIO ALFARO', 'MANABÍ'],
  ['1306', 'JIPIJAPA', 'MANABÍ'],
  ['1307', 'JUNÍN', 'MANABÍ'],
  ['1308', 'MANTA', 'MANABÍ'],
  ['1309', 'MONTECRISTI', 'MANABÍ'],
  ['1310', 'PAJÁN', 'MANABÍ'],
  ['1311', 'PICHINCHA', 'MANABÍ'],
  ['1312', 'ROCAFUERTE', 'MANABÍ'],
  ['1313', 'SANTA ANA', 'MANABÍ'],
  ['1314', 'SUCRE', 'MANABÍ'],
  ['1315', 'TOSAGUA', 'MANABÍ'],
  ['1316', '24 DE MAYO', 'MANABÍ'],
  ['1317', 'PEDERNALES', 'MANABÍ'],
  ['1318', 'OLMEDO', 'MANABÍ'],
  ['1319', 'PUERTO LÓPEZ', 'MANABÍ'],
  ['1320', 'JAMA', 'MANABÍ'],
  ['1321', 'JARAMIJÓ', 'MANABÍ'],
  ['1322', 'SAN VICENTE', 'MANABÍ'],
  ['1401', 'MORONA', 'MORONA SANTIAGO'],
  ['1402', 'GUALAQUIZA', 'MORONA SANTIAGO'],
  ['1403', 'LIMÓN INDANZA', 'MORONA SANTIAGO'],
  ['1404', 'PALORA', 'MORONA SANTIAGO'],
  ['1405', 'SANTIAGO', 'MORONA SANTIAGO'],
  ['1406', 'SUCÚA', 'MORONA SANTIAGO'],
  ['1407', 'HUAMBOYA', 'MORONA SANTIAGO'],
  ['1408', 'SAN JUAN BOSCO', 'MORONA SANTIAGO'],
  ['1409', 'TAISHA', 'MORONA SANTIAGO'],
  ['1410', 'LOGROÑO', 'MORONA SANTIAGO'],
  ['1411', 'PABLO SEXTO', 'MORONA SANTIAGO'],
  ['1412', 'TIWINTZA', 'MORONA SANTIAGO'],
  ['1413', 'SEVILLA DON BOSCO', 'MORONA SANTIAGO'],
  ['1501', 'TENA', 'NAPO'],
  ['1503', 'ARCHIDONA', 'NAPO'],
  ['1504', 'EL CHACO', 'NAPO'],
  ['1507', 'QUIJOS', 'NAPO'],
  ['1509', 'CARLOS JULIO AROSEMENA TOLA', 'NAPO'],
  ['1601', 'PASTAZA', 'PASTAZA'],
  ['1602', 'MERA', 'PASTAZA'],
  ['1603', 'SANTA CLARA', 'PASTAZA'],
  ['1604', 'ARAJUNO', 'PASTAZA'],
  ['1701', 'DISTRITO METROPOLITANO DE QUITO', 'PICHINCHA'],
  ['1702', 'CAYAMBE', 'PICHINCHA'],
  ['1703', 'MEJÍA', 'PICHINCHA'],
  ['1704', 'PEDRO MONCAYO', 'PICHINCHA'],
  ['1705', 'RUMIÑAHUI', 'PICHINCHA'],
  ['1707', 'SAN MIGUEL DE LOS BANCOS', 'PICHINCHA'],
  ['1708', 'PEDRO VICENTE MALDONADO', 'PICHINCHA'],
  ['1709', 'PUERTO QUITO', 'PICHINCHA'],
  ['1801', 'AMBATO', 'TUNGURAHUA'],
  ['1802', 'BAÑOS DE AGUA SANTA', 'TUNGURAHUA'],
  ['1803', 'CEVALLOS', 'TUNGURAHUA'],
  ['1804', 'MOCHA', 'TUNGURAHUA'],
  ['1805', 'PATATE', 'TUNGURAHUA'],
  ['1806', 'QUERO', 'TUNGURAHUA'],
  ['1807', 'SAN PEDRO DE PELILEO', 'TUNGURAHUA'],
  ['1808', 'SANTIAGO DE PÍLLARO', 'TUNGURAHUA'],
  ['1809', 'TISALEO', 'TUNGURAHUA'],
  ['1901', 'ZAMORA', 'ZAMORA CHINCHIPE'],
  ['1902', 'CHINCHIPE', 'ZAMORA CHINCHIPE'],
  ['1903', 'NANGARITZA', 'ZAMORA CHINCHIPE'],
  ['1904', 'YACUAMBI', 'ZAMORA CHINCHIPE'],
  ['1905', 'YANTZAZA', 'ZAMORA CHINCHIPE'],
  ['1906', 'EL PANGUI', 'ZAMORA CHINCHIPE'],
  ['1907', 'CENTINELA DEL CÓNDOR', 'ZAMORA CHINCHIPE'],
  ['1908', 'PALANDA', 'ZAMORA CHINCHIPE'],
  ['1909', 'PAQUISHA', 'ZAMORA CHINCHIPE'],
  ['2001', 'SAN CRISTÓBAL', 'GALÁPAGOS'],
  ['2002', 'ISABELA', 'GALÁPAGOS'],
  ['2003', 'SANTA CRUZ', 'GALÁPAGOS'],
  ['2101', 'LAGO AGRIO', 'SUCUMBÍOS'],
  ['2102', 'GONZALO PIZARRO', 'SUCUMBÍOS'],
  ['2103', 'PUTUMAYO', 'SUCUMBÍOS'],
  ['2104', 'SHUSHUFINDI', 'SUCUMBÍOS'],
  ['2105', 'SUCUMBÍOS', 'SUCUMBÍOS'],
  ['2106', 'CASCALES', 'SUCUMBÍOS'],
  ['2107', 'CUYABENO', 'SUCUMBÍOS'],
  ['2201', 'FRANCISCO DE ORELLANA', 'ORELLANA'],
  ['2202', 'AGUARICO', 'ORELLANA'],
  ['2203', 'LA JOYA DE LOS SACHAS', 'ORELLANA'],
  ['2204', 'LORETO', 'ORELLANA'],
  ['2301', 'SANTO DOMINGO', 'SANTO DOMINGO DE LOS TSÁCHILAS'],
  ['2302', 'LA CONCORDIA', 'SANTO DOMINGO DE LOS TSÁCHILAS'],
  ['2401', 'SANTA ELENA', 'SANTA ELENA'],
  ['2402', 'LA LIBERTAD', 'SANTA ELENA'],
  ['2403', 'SALINAS', 'SANTA ELENA'],
];

export const CANTONES_INEC: CantonInec[] = DATOS.map(([codigo, canton, provincia]) => ({ codigo, canton, provincia, codigoProvincia: codigo.slice(0, 2) }));

// Distrito Metropolitano de Quito: activa las RTQ 2026 del Cuerpo de Bomberos de Quito (matriz 9.3).
export const CODIGO_QUITO = '1701';

export const sinTildes = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();

export function cantonPorCodigo(codigo: string | null | undefined): CantonInec | undefined {
  return codigo ? CANTONES_INEC.find(c => c.codigo === codigo) : undefined;
}

export function esQuitoInec(codigo: string | null | undefined): boolean {
  return codigo === CODIGO_QUITO;
}

// Buscador: por nombre del cantón o de la provincia, sin importar tildes ni mayúsculas.
export function buscarCantones(texto: string, limite = 20): CantonInec[] {
  const t = sinTildes(texto);
  if (!t) return [];
  const empieza = CANTONES_INEC.filter(c => sinTildes(c.canton).startsWith(t));
  const contiene = CANTONES_INEC.filter(c => !empieza.includes(c) && (sinTildes(c.canton).includes(t) || sinTildes(c.provincia).includes(t)));
  return empieza.concat(contiene).slice(0, limite);
}

// Para el texto libre guardado antes de M34 (site_canton): nombre exacto sin tildes; "Quito" es el DMQ.
export function cantonPorNombre(nombre: string | null | undefined): CantonInec | undefined {
  if (!nombre) return undefined;
  const t = sinTildes(nombre);
  if (t === 'QUITO' || t === 'DMQ') return cantonPorCodigo(CODIGO_QUITO);
  const exactos = CANTONES_INEC.filter(c => sinTildes(c.canton) === t);
  return exactos.length === 1 ? exactos[0] : undefined;
}
